export const pauseNAskConfigName = "wavicleacademy";

export const getPauseAndAskUrl = (courseId, question, tutorEmail, studentEmail) => {
    return `https://pauseaskapi.wdc-wavicledata.com/?question=${encodeURIComponent(question)}&config=${pauseNAskConfigName}&courseid=${courseId}&tutoremail=${tutorEmail}&studentemail=${studentEmail}`;
}